import { useCallback } from 'react';
import { Text, Button, Flex, Box } from '@radix-ui/themes';
import { Dialog } from '@/components/shared/dialog';
import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import styles from './VerifySnippetDialog.module.scss';

interface DeleteCollectionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  collectionName: string;
  onDeleteCollection: () => void;
}

export function DeleteCollectionDialog({
  open,
  onOpenChange,
  collectionName,
  onDeleteCollection,
}: DeleteCollectionDialogProps) {
  const handleDelete = useCallback(() => {
    onDeleteCollection();
    onOpenChange(false);
  }, [onDeleteCollection, onOpenChange]);

  const handleCancel = useCallback(() => {
    onOpenChange(false);
  }, [onOpenChange]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <Dialog.Content size="medium" className={styles.dialogContent}>
        <Dialog.Close className={styles.closeButton} />
        <Flex direction="column" gap="6" p="5">
          <Flex direction="column" gap="1">
            <Text size="4" weight="medium" className={styles.title}>
              Delete Collection
            </Text>
            <Text size="3" color="gray" className={styles.subtitle}>
              Are you sure you want to delete "{collectionName}"?
            </Text>
          </Flex>

          <Box p="2" px="3" className={styles.infoMessage}>
            <Flex gap="2" align="start">
              <ExclamationTriangleIcon width={16} height={16} color="orange" />
              <Text size="2" weight="medium" className={styles.infoText}>
                This action cannot be undone. All snippets and sub-collections within this
                collection will be permanently deleted.
              </Text>
            </Flex>
          </Box>

          <Flex gap="3" justify="end">
            <Button variant="ghost" size="2" onClick={handleCancel} className={styles.cancelButton}>
              <Text size="3" color="gray">
                Cancel
              </Text>
            </Button>
            <Button
              variant="solid"
              color="red"
              size="2"
              highContrast
              onClick={handleDelete}
              className={styles.verifyButton}
            >
              Delete
            </Button>
          </Flex>
        </Flex>
      </Dialog.Content>
    </Dialog>
  );
}
